import { render, staticRenderFns } from "./Brochures.vue?vue&type=template&id=9470a7a4&scoped=true&"
import script from "./Brochures.vue?vue&type=script&lang=js&"
export * from "./Brochures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9470a7a4",
  null
  
)

export default component.exports